module.exports = __webpack_public_path__ + "static/media/shaheen.8275a441.jpg";